export const pescaraNuovaSegreteria2025 = {
  id: 'static-pescara-nuova-segreteria-2025',
  slug: 'pescara-nuova-segreteria-2025',
  title: 'Pescara: una nuova segreteria provinciale, un nuovo slancio per UNASCA',
  excerpt: 'Con l\'elezione della nuova segreteria provinciale UNASCA Studi di Pescara, guidata da Simone Brigida, si rafforza il percorso di crescita e consolidamento della nostra associazione.',
  body: `
    <div style="background: white; color: #001510; padding: 2rem; border-radius: 12px; margin: 2rem 0; text-align: center; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); border: 2px solid #00bf8f;">
      <h2 style="font-size: 2rem; margin-bottom: 1rem; font-weight: 600; color: #001510;">
        <i class="fas fa-users"></i> Nuova Segreteria Provinciale Studi per Pescara
      </h2>
      <p style="color: #2c3e50; font-size: 1.1rem; line-height: 1.6;">
        Con l'elezione della nuova segreteria provinciale UNASCA Studi di Pescara, guidata da <strong>Simone Brigida</strong> come Segretario Provinciale e composta da un team di professionisti esperti, si rafforza ulteriormente il percorso di crescita e consolidamento della nostra associazione in Abruzzo.
      </p>
    </div>

    <p>C'è una bella aria di novità in provincia di Pescara. Con l'elezione della nuova segreteria provinciale UNASCA Studi, si rafforza ulteriormente il percorso di crescita e consolidamento della nostra associazione.</p>

    <h2><i class="fas fa-chart-line"></i> Una Crescita che Parla Chiaro</h2>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-trophy"></i> I Numeri del Successo
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 UNASCA continua a crescere in termini di <strong>iscritti e rappresentatività</strong>
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 Aumento costante della <strong>credibilità istituzionale</strong>
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 Consolidamento della <strong>visione strategica</strong> dell'associazione
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 Rafforzamento della presenza territoriale in tutto il paese
        </li>
      </ul>
    </div>

    <p>Questo risultato non è frutto del caso, ma dell'impegno costante di ogni singolo componente della nostra famiglia associativa – dalla segreteria nazionale fino all'ultimo associato sul territorio.</p>

    <blockquote style="background: linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%); border-left: 4px solid #f59e0b; padding: 1.5rem; margin: 2rem 0; border-radius: 0 12px 12px 0; font-style: italic; font-size: 1.1rem; color: #2c3e50;">
      È grazie a questo spirito collettivo che oggi possiamo dire con orgoglio che la famiglia UNASCA è più grande, più forte e più unita. E, evidentemente, se cresciamo, un motivo c'è.
    </blockquote>

    <h2><i class="fas fa-handshake"></i> La Nuova Squadra</h2>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #001510; margin-bottom: 1rem;">
        <i class="fas fa-star"></i> La Nuova Squadra di Pescara
      </h3>
      <p>Alla guida della nuova segreteria provinciale di Pescara c'è ora <strong>Simone Brigida</strong> come Segretario Provinciale, al quale rivolgiamo i nostri più sentiti auguri di buon lavoro. Siamo certi che saprà affrontare questa responsabilità con passione, competenza e spirito di squadra.</p>

      <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 1.5rem 0;">
        <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
          <i class="fas fa-users"></i> Composizione della Segreteria
        </h3>
        <ul style="list-style: none; padding: 0;">
          <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
            📈 <strong>Segretario Provinciale:</strong> <strong>Simone Brigida</strong>
          </li>
          <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
            📈 <strong>Vicesegretario:</strong> <strong>Antonio Vaccaro</strong>
          </li>
          <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
            📈 <strong>Consiglieri Provinciali:</strong> <strong>Timperio Giuseppe</strong>, <strong>Martina Pompa</strong> e <strong>Miriam Taricani</strong>
          </li>
          <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
            📈 <strong>Consigliere Nazionale:</strong> <strong>Alessandro Zappacosta</strong>
          </li>
        </ul>
      </div>

      <p>La loro esperienza nel settore e la profonda conoscenza delle dinamiche territoriali rappresentano una garanzia per il futuro sviluppo di UNASCA in provincia di Pescara. Un team completo e competente che saprà rappresentare al meglio gli interessi degli associati abruzzesi.</p>
    </div>

    <h2><i class="fas fa-heart"></i> Riconoscimenti e Ringraziamenti</h2>

    <p>Un ringraziamento speciale va a <strong>Gilberto Negretti</strong>, <strong>Alessandro Zappacosta</strong> e <strong>Alessandro Colalongo</strong>, che con impegno e determinazione hanno reso possibile la costituzione di questa nuova realtà organizzativa.</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-cogs"></i> Il Lavoro "Dietro le Quinte"
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 Coordinamento delle attività preparatorie
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 Dialogo costante con gli associati del territorio
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          📈 Organizzazione delle procedure elettorali
        </li>
      </ul>
    </div>

    <p>Il loro lavoro "dietro le quinte" ha avuto un ruolo fondamentale per questo risultato, dimostrando ancora una volta come il successo di UNASCA sia sempre frutto di un impegno collettivo e condiviso.</p>

    <div style="text-align: center; margin: 2rem 0;">
      <img src="/images/PESCARA.jpg" alt="Pescara - Nuova Segreteria Provinciale UNASCA" style="width: 100%; max-width: 800px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <p style="margin-top: 1rem; font-size: 0.9rem; color: #6c757d; text-align: center; font-style: italic;">
        <i class="fas fa-map-marker-alt"></i> Pescara - Una nuova segreteria provinciale per un nuovo slancio UNASCA
      </p>
    </div>

    <h2><i class="fas fa-flag"></i> Conclusioni</h2>
    
    <p>La strada è tracciata: continuiamo a lavorare insieme, a crescere insieme, e a scrivere – insieme – una nuova pagina per UNASCA, a Pescara e in tutta Italia.</p>
    
    <p>Questo nuovo capitolo della storia di UNASCA in Abruzzo rappresenta la conferma di una strategia vincente basata su:</p>
    
    <ul style="margin-left: 2rem; margin-bottom: 2rem;">
      <li><strong>Competenza professionale</strong> e aggiornamento continuo</li>
      <li><strong>Spirito di squadra</strong> e collaborazione</li>
      <li><strong>Radicamento territoriale</strong> e vicinanza agli associati</li>
      <li><strong>Visione strategica</strong> per il futuro del settore</li>
    </ul>

    <blockquote style="background: linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%); border-left: 4px solid #f59e0b; padding: 1.5rem; margin: 2rem 0; border-radius: 0 12px 12px 0; font-style: italic; font-size: 1.1rem; color: #2c3e50;">
      Con Simone Brigida e la nuova segreteria provinciale, UNASCA Pescara è pronta ad affrontare le sfide future con rinnovato entusiasmo e determinazione.
    </blockquote>
  `,
  featuredImage: '/images/PESCARA.jpg',
  category: {
    id: 'eventi',
    name: 'Eventi',
    slug: 'eventi',
    color: '#8B5CF6'
  },
  tags: ['Pescara', 'Segreteria Provinciale', 'Simone Brigida', 'Abruzzo', 'Crescita'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-07-05T10:00:00Z',
  createdAt: '2025-07-05T10:00:00Z',
  updatedAt: '2025-07-05T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 4
};

